module.exports = {
	"el": {
		"help-tool": {
			"button-text": "Βοήθεια",
			"support-button": "Λάβετε υποστήριξη",
			"support-page": {
				"create-ticket": {
					"title": "Λάβετε υποστήριξη",
					"instructions": "Υποβάλετε ένα αίτημα παρακάτω και θα επικοινωνήσουμε μαζί σας εντός μίας εργάσιμης ημέρας.",
					"related-content": {
						"title": "Αυτά μπορεί να βοηθήσουν στην επίλυση του προβλήματός σας"
					},
					"fields": {
						"mid": {
							"label": "Επιλογή καταστήματος",
							"validation": "Απαιτείται κατάστημα"
						},
						"phoneNumber": {
							"label": "Αριθμός τηλεφώνου (προαιρετικό)"
						},
						"topic": {
							"question": "Με τι σχετίζεται η ερώτησή σας;",
							"label": "Επιλέξτε ένα θέμα",
							"validation": "Απαιτείται θέμα",
							"options": {
								"orders": "Παραγγελίες",
								"settlements": "Διακανονισμοί",
								"agreements": "Συμφωνίες",
								"others": "Άλλα"
							}
						},
						"subject": {
							"label": "Θέμα",
							"validation": "Απαιτείται θέμα"
						},
						"description": {
							"label": "Μήνυμα",
							"validation": "Απαιτείται περιγραφή"
						},
						"attachment": {
							"label": "Προσθήκη επισυνάψεων",
							"button": "Μεταφόρτωση",
							"info": "Η προσθήκη στιγμιότυπων οθόνης θα μας βοηθήσει να επιλύσουμε το θέμα ευκολότερα.",
							"supportedFileTypes": "Υποστηριζόμενοι τύποι αρχείων: .png, .jpg, .pdf",
							"error": "Το σύνολο των αρχείων δεν πρέπει να υπερβαίνει τα {maxSize} MB"
						}
					},
					"submit": "Υποβολή αιτήματος",
					"service-unavailable-error": "Σφάλμα! Κάτι πήγε στραβά, προσπαθήστε ξανά σε μερικά λεπτά. Αν αυτό συνεχιστεί, μεταβείτε στο {link} για βοήθεια.",
					"generic-error": "Δεν μπορέσαμε να επεξεργαστούμε το αίτημά σας. Τα συστήματά μας δεν επικοινωνούν μεταξύ τους αυτήν τη στιγμή. Προσπαθήστε να κάνετε ανανέωση της σελίδας ή επιστρέψτε αργότερα. Αν αυτό συνεχιστεί, μεταβείτε στο {link} για βοήθεια.",
					"contact-link": "επικοινωνήστε μαζί μας"
				},
				"view-ticket": {
					"title": "Ολοκληρώθηκε!",
					"details": "Λάβαμε το αίτημά σας και θα σας απαντήσουμε εντός μίας εργάσιμης ημέρας. Ακολουθούν τα στοιχεία σας:",
					"ticket": "Αρ. αιτήματος{ticketId}",
					"email": "Email: {email}",
					"status": "Μπορείτε να παρακολουθήσετε την κατάσταση στη σελίδα «Υποστήριξη».",
					"track": "Παρακολούθηση κατάστασης"
				}
			},
			"header": {
				"homeLink": "Επαναφορά"
			},
			"home": {
				"greeting": "Γεια σας {givenName}! Πώς μπορούμε να σας βοηθήσουμε;",
				"topics": "Πώς μπορούμε να βοηθήσουμε;"
			},
			"topics": {
				"expandButton": "Περισσότερα"
			},
			"feedback": {
				"title": "Ήταν αυτό χρήσιμο;",
				"optionYes": "Ναι, αυτό ήταν χρήσιμο",
				"optionNo": "Όχι, χρειάζομαι περισσότερη βοήθεια",
				"positiveFeedback": "Σας ευχαριστούμε για τα θετικά σχόλια, μας βοηθούν ιδιαίτερα στο να σας παρέχουμε πιο σχετικά άρθρα στο μέλλον."
			},
			"freeTextFeedback": {
				"title": "Βοηθήστε μας να βελτιωθούμε",
				"placeholder": "Γιατί δεν βρήκατε χρήσιμο αυτό το περιεχόμενο;",
				"submitButton": "Αποστολή",
				"feedbackMessage": "Σας ευχαριστούμε για τα σχόλιά σας, μας βοηθούν ιδιαίτερα στο να σας παρέχουμε πιο σχετικά άρθρα στο μέλλον."
			},
			"relatedContent": {
				"title": "Σχετικό περιεχόμενο"
			},
			"search": {
				"buttonLabel": "Αναζήτηση",
				"input": "Αναζήτηση για άρθρα…",
				"loading": "Φόρτωση…",
				"results": {
					"contact": "Δεν μπορέσατε να βρείτε τη βοήθεια που χρειάζεστε;",
					"empty": "Λυπούμαστε, δεν βρέθηκαν αποτελέσματα για το αίτημά σας. Προσπαθήστε να κάνετε αναζήτηση για διαφορετικό όρο.",
					"singleTopicFound": "Βρήκαμε 1 θέμα",
					"multipleTopicsFound": "Βρήκαμε {count} θέματα",
					"singleArticleFound": "Βρήκαμε 1 άρθρο",
					"multipleArticlesFound": "Βρήκαμε {count} άρθρα"
				}
			},
			"contact": {
				"title": "Επικοινωνήστε μαζί μας",
				"channelsIntro": "Επικοινωνήστε μαζί μας για να σας βοηθήσουμε.",
				"businessDetailsTitle": "Τα επαγγελματικά σας στοιχεία",
				"businessDetailsName": "Όνομα επιχείρησης",
				"businessDetailsEmail": "Email",
				"businessDetailsMid": "Αναγνωριστικό εμπόρου",
				"phone": {
					"title": "Καλέστε μας",
					"paragraph": "Μπορείτε να μας καλέσετε κατά τη διάρκεια των εργάσιμων ωρών και ημερών. Αν βρίσκεστε στη Σουηδία ή το Ηνωμένο Βασίλειο, μπορείτε επίσης να μας καλέσετε το σαββατοκύριακο μεταξύ 10 π.μ. και 4 μ.μ."
				},
				"email": {
					"title": "Στείλτε μας email",
					"paragraph": "Στείλτε μας ένα email και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατόν."
				}
			},
			"errorBoundary": {
				"title": "Προέκυψε κάποιο σφάλμα",
				"message": "Λυπούμαστε, αλλά υπήρξε κάποιο σφάλμα. Μπορείτε να κάνετε κλικ στο κουμπί «Επιστροφή» παρακάτω για να επιστρέψετε στο εργαλείο βοήθειας, ή στο κουμπί «Λάβετε υποστήριξη» για να επικοινωνήσετε μαζί μας.",
				"resetButton": "Επιστροφή",
				"errorId": "Αναγνωριστικό σφάλματος: {errorId}"
			},
			"tour": {
				"prev": "Προηγούμενο",
				"next": "Επόμενο",
				"done": "Ολοκληρώθηκε"
			},
			"notAvailableMobile": {
				"title": "Μη διαθέσιμο",
				"buttonBack": "Επιστροφή",
				"paragraph": "Αυτό το περιεχόμενο δεν είναι διαθέσιμο στη συσκευή σας. Δοκιμάστε να το ανοίξετε σε μια συσκευή με μεγαλύτερο μέγεθος οθόνης, όπως έναν επιτραπέζιο υπολογιστή."
			},
			"shareButton": {
				"title": {
					"article": "Μοιραστείτε έναν βαθύ σύνδεσμο (deep link) προς αυτό το άρθρο",
					"topic": "Μοιραστείτε έναν βαθύ σύνδεσμο (deep link) προς αυτό το θέμα",
					"tour": "Μοιραστείτε έναν βαθύ σύνδεσμο (deep link) προς αυτήν την περιήγηση"
				},
				"radioItemHome": "Εφαρμογή αρχικής σελίδας",
				"descriptionHome": "Ανοίγει το άρθρο βοήθειας στην αρχική σελίδα της Πύλης Εμπόρων",
				"radioItemCurrent": "Τρέχουσα σελίδα",
				"descriptionCurrent": "Ανοίγει το άρθρο βοήθειας στην τρέχουσα σελίδα"
			},
			"marketSelector": {
				"whichMarketToContact": "Με ποια αγορά θέλετε να επικοινωνήσετε;"
			}
		},
		"orientation": {
			"title": "Μάθετε πώς…"
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Γεια σας {name}! 👋 Είμαι ο βοηθός Klarna σας.",
				"whatDoYouNeedHelpWithPart2": "Σε πολλές περιπτώσεις, η χρήση μου θα σας βοηθήσει να λύσετε το ερώτημά σας σε λιγότερο από 5 λεπτά.",
				"whatDoYouNeedHelpWithPart3": "Πώς μπορώ να σας βοηθήσω σήμερα;",
				"selectSupportChannel": "Επιλέξτε ένα κανάλι για να επικοινωνήσετε με την υπηρεσία υποστήριξής μας.",
				"selectPayoutIssue": "Τέλεια! Επιλέξτε ένα θέμα που σχετίζεται με τις πληρωμές 👇",
				"selectOrderIssue": "Τέλεια! Επιλέξτε ένα θέμα που σχετίζεται με τις παραγγελίες 👇",
				"capturedOrders": "Έχετε {link1} παραγγελίες;",
				"capturedOrdersLink1": "αποτυπωμένες",
				"notPaidOrder": {
					"isScheduleFollowed": "Παρακολουθείται (συμπεριλαμβανομένης της καθυστέρησης πληρωμής) {link1};",
					"isScheduleFollowedLink1": "Πρόγραμμα αποπληρωμών",
					"isHoldbackOrDebt": "Εάν η προθεσμία πληρωμής έχει παρέλθει, ελέγξτε το {link1}. Υπάρχει κάποια παρακράτηση ή χρέος λόγω επιστροφών/αντιστροφής;",
					"isHoldbackOrDebtLink1": "τελευταίο αρχείο διακανονισμού"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Επαληθεύστε την ημερομηνία αποτύπωσης των παραγγελιών που αναμένατε να πληρωθείτε και λάβετε υπόψη την καθυστέρηση πληρωμής σας. Μπορείτε να βρείτε τις παραγγελίες {link1}. Αποτυπώνονται οι παραγγελίες που αναμένεται να εξοφληθούν;",
					"isScheduleFollowedLink1": "εδώ"
				},
				"changePaymentFrequency": "Έχετε λάβει περισσότερες από 30 αποτυπωμένες παραγγελίες ανά μήνα σε περίοδο 3 μηνών;",
				"whenWillGetPaid": "Η ημερομηνία πληρωμής εξαρτάται από το πρόγραμμα αποπληρωμών σας και την καθυστέρηση αποπληρωμής που αναφέρεται στη σύμβασή σας (Όροι και Προϋποθέσεις). Αν δεν είστε σίγουροι για τη ρύθμιση της αποπληρωμής σας, μπορείτε να την ελέγξετε στους {link1}. Τηρείται το πρόγραμμα πληρωμών (+καθυστέρηση πληρωμής);",
				"whenWillGetPaidLink1": "Διακανονισμοί",
				"thatHelped": "Σας ευχαριστούμε για τα θετικά σχόλια, μας βοηθούν ιδιαίτερα στο να σας παρέχουμε πιο σχετική βοήθεια στο μέλλον. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Κατάλαβα! Έχετε παραγγελίες που δεν έχουν αποτυπωθεί;",
					"haveUncapturedOrdersPart2": "Εάν δεν ξέρετε πώς να το ψάξετε, μεταβείτε στο {link1}.",
					"haveUncapturedOrdersPart2Link1": "αυτή την σελίδα",
					"expirationDateSurpassed": "Έχει παρέλθει η ημερομηνία λήξης; (συνήθως 28 ημέρες)",
					"customerCreditPaymentMethod": "Επέλεξε ο πελάτης πιστωτικό τρόπο πληρωμής (τιμολόγιο, λογαριασμός, πάγια χρέωση);",
					"isOrderCaptured": "Είναι η παραγγελία {link1};",
					"isOrderCapturedLink1": "αποτυπωμένη"
				}
			},
			"options": {
				"payout": "Αποπληρωμή",
				"orders": "Παραγγελίες",
				"otherIssue": "Άλλα προβλήματα",
				"whenPaidOrderNext": "Πότε θα πληρωθώ την επόμενη φορά;",
				"notPaidOrder": "Δεν πληρώθηκα",
				"paidWrongAmount": "Πληρώθηκα λάθος ποσό",
				"changeHowOftenPaid": "Θέλω να αλλάξω πόσο συχνά πληρώνομαι",
				"dontKnowHowToCaptureOrder": "Δεν ξέρω πώς να αποτυπώσω μια παραγγελία",
				"missedCaptureDeadline": "Έχασα την προθεσμία αποτύπωσης",
				"needToRefundAnOrder": "Πρέπει να λάβω Επιστροφή χρημάτων για μια παραγγελία",
				"yes": "Ναι",
				"no": "Όχι",
				"partially": "Μερική",
				"iNeedMoreHelp": "Χρειάζομαι περισσότερη βοήθεια",
				"thatHelped": "Αυτό βοήθησε",
				"contactSupportChannel": "Επικοινωνήστε με τα κανάλια υποστήριξης"
			},
			"explanations": {
				"noCapturedOrders": "Πρώτα πρέπει να {link1}. Όταν αποτυπώσετε την παραγγελία, θα πληρώσουμε το ποσό στον τραπεζικό σας λογαριασμό. Έξοδα, επιστροφές και άλλες επιβαρύνσεις θα αφαιρούνται από αυτό το ποσό.",
				"noCapturedOrdersLink1": "αποτύπωσετε μία παραγγελία",
				"feesReturnsHoldbacks": "Έξοδα, επιστροφές και άλλες επιβαρύνσεις θα αφαιρεθούν από το ποσό πληρωμής. Ελέγξτε εάν έχετε κάποια παρακράτηση ή χρέος λόγω επιστροφών στο {link1}",
				"feesReturnsHoldbacksLink1": "τελευταίο αρχείο διακανονισμού",
				"notPaidOrder": {
					"scheduleFollowed": "Μόλις αποτυπώσετε μια παραγγελία, θα πληρώσουμε το ποσό στον τραπεζικό σας λογαριασμό σύμφωνα με το πρόγραμμα αποπληρωμών σας. Έξοδα, επιστροφές και άλλες επιβαρύνσεις θα αφαιρούνται από αυτό το ποσό. Ελέγξτε την αξία της πληρωμής σας στο {link1}.",
					"scheduleFollowedLink1": "τελευταίο αρχείο διακανονισμού",
					"noHoldback": "Βεβαιωθείτε ότι έχετε καταχωρίσει τα σωστά στοιχεία τραπεζικού λογαριασμού για το νόμισμα της πληρωμής {link1}.",
					"noHoldbackLink1": "εδώ",
					"withHoldback": "Εάν η αξία των παραγγελιών υπερβαίνει το χρέος, βεβαιωθείτε ότι έχετε καταχωρίσει τα σωστά στοιχεία τραπεζικού λογαριασμού για το νόμισμα της πληρωμής {link1}.",
					"withHoldbackLink1": "εδώ"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Θα λάβετε την επόμενη πληρωμή σύμφωνα με το πρόγραμμα πληρωμών + προθεσμία πληρωμών."
				},
				"changePaymentFrequency": {
					"isAble": "Συνεχίστε επικοινωνώντας με την υποστήριξή μας μέσω των παρακάτω καναλιών.",
					"isUnable": "Δυστυχώς δεν πληροίτε τις προϋποθέσεις για να αλλάξετε το πρόγραμμα πληρωμών σας."
				},
				"orders": {
					"uncapturedDynamicYes": "Βλέπω ότι έχετε {number} αποτυπωμένες παραγγελίες.",
					"uncapturedDynamicNo": "Βλέπω ότι δεν έχετε αποτυπωμένες παραγγελίες",
					"uncapturedYesPart1": "Ώρα να αποτυπώσετε παραγγελίες! Για να το κάνετε αυτό,",
					"uncapturedYesPart2": "1. Μεταβείτε στη σελίδα της παραγγελίας {link1}.",
					"uncapturesYesPart2Link1": "κάνοντας κλικ εδώ",
					"uncapturedYesPart3": "2. Κάντε κλικ στον αριθμό αναφοράς Klarna της παραγγελίας που θέλετε να καταγράψετε",
					"uncapturedYesPart4": "3. Επιλέξτε τα άρθρα ή προσθέστε ένα ποσό που θέλετε να καταγράψετε",
					"uncapturedYesPart5": "4. Πατήστε \"Αποτύπωση\"",
					"uncapturedNoPart1": "Για να αποτυπώσετε μια παραγγελία, πρέπει πρώτα να έχετε παραγγελίες για αποτύπωση.",
					"uncapturedNoPart2": "Όταν αποτυπώνετε μιας παραγγελία σημαίνει ότι επιβεβαιώνετε ότι η παραγγελία έχει αποσταλεί στον πελάτη. Αυτό θα πρέπει να γίνεται πάντα την ίδια ημέρα που αποστέλλεται η παραγγελία για κάθε παραγγελία. Όταν αποτυπώνετε μια παραγγελία, μας ενημερώνετε επίσης ότι θα πρέπει να ενεργοποιήσουμε μια πληρωμή σε εσάς για αυτήν την παραγγελία. Διαβάστε περισσότερα για το πώς να αποτυπώσετε μια παραγγελία {link1}.",
					"uncapturedNoLink1": "εδώ",
					"customerCreditPaymentMethodNo": "Δυστυχώς, δεν μπορούμε να παρατείνουμε μια παραγγελία που έχει λήξει. Θα πρέπει να αναδημιουργήσετε την παραγγελία.",
					"expirationDateSurpassedYes": "Επιτρέψτε μας να σας βοηθήσουμε να παρατείνουμε την παραγγελία, επικοινωνήστε με την υποστήριξή μας μέσω ενός από τα παρακάτω κανάλια.",
					"expirationDateSurpassedNo": "Μετάβαση στο {link1} Επιλέξτε την παραγγελία, κάνοντας τικ στο κουτάκι δίπλα στον αριθμό αναφοράς της Klarna. Πατήστε το κουμπί Παράταση ημερομηνίας λήξης και επιβεβαιώστε το αίτημά σας.",
					"expirationDateSurpassedNoLink1": "Παραγγελίες> Προς αποτύπωση",
					"isOrderCapturedYesPart1": "Επιλέξτε τα προϊόντα για τα οποία επιθυμείτε επιστροφή χρημάτων και κάντε κλικ στην Επιστροφή χρημάτων. Μπορείτε επίσης να κάνετε κλικ πρώτα στην Επιστροφή χρημάτων και στη συνέχεια να εισαγάγετε το ποσό που επιθυμείτε να επιστρέψετε – εσείς επιλέγετε τον τρόπο που σας βολεύει καλύτερα.",
					"isOrderCapturedYesPart2": "Ο πελάτης σας θα λάβει πίσω το ποσό που ήδη πλήρωσε μέσα σε 2-5 εργάσιμες ημέρες. Και θα δείτε αυτό το ποσό να αφαιρείται από την επόμενη αποπληρωμή σας.",
					"isOrderCapturedNo": "Εάν έχετε μία μη αποτυπωμένη παραγγελία για την οποία δεν θα κάνετε αποστολή, μπορείτε να {link1} ολόκληρη την παραγγελία. Μεταβείτε στη {link2} και κάντε κλικ στο Ακύρωση παραγγελίας.",
					"isOrderCapturedNoLink1": "ακυρώσετε",
					"isOrderCapturedNoLink2": "σελίδα παραγγελίας",
					"refundPartiallyCaptured": "Εάν αποτυπώσετε μερικώς την παραγγελία για τα προϊόντα στα οποία έγινε αποστολή και δεν θα ολοκληρώσετε την αποστολή για τα υπόλοιπα, θα πρέπει να απελευθερώσετε το μη αποτυπωμένο τμήμα της παραγγελίας. Μεταβείτε στο {link1}, κάντε κλικ στο Περισσότερες ενέργειες και επιλέξτε Έκδοση.",
					"refundPartiallyCapturedLink1": "σελίδα παραγγελίας"
				}
			},
			"messages": {
				"sorryToHearThat": "Λυπάμαι που δεν βοήθησα. Σύντομα θα ανακατευθυνθείτε για να επικοινωνήσετε με την υποστήριξή μας."
			},
			"button": {
				"label": "Λάβετε υποστήριξη"
			},
			"contact": {
				"chat": "Συνομιλήστε με έναν εκπρόσωπό μας",
				"ticket": "Υποβολή εισιτηρίου",
				"times": {
					"minutes": "Χρόνος αναμονής: {time} λεπτό(ά)",
					"hours": "Χρόνος αναμονής: {time} ώρα(ες)",
					"days": "Χρόνος αναμονής: {time} μέρα(ες)"
				}
			}
		}
	}
};